__turbopack_context__.v({
  "placeholder": "InlineFilters-Switcher-module-scss-module__pu96LG__placeholder",
  "underline": "InlineFilters-Switcher-module-scss-module__pu96LG__underline",
  "value": "InlineFilters-Switcher-module-scss-module__pu96LG__value",
});
